<div class="main">
  <div class="row clear top-banner">
    <div class="col-lg-4 col-md-12 col-sm-12 clear">
      <img src="assets/img/engineers-analyzing-data-digital-tablet.png" class="img-banner" alt="banner">
    </div>
    <div class="col-lg-8 col-md-12 col-sm-12 clear">
      <div class="top-banner-text-container">
        <div>
          <div class="top-banner-text-md">About Us</div>
          <div class="top-banner-text-lg">
            What is the Private Electrical<br>
            Contractors Certified by<br>
            Meralco (PECCBM) Program?<br>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br>
    <br>
      <div class="content">
        <div class="row clear">
          <div class="col-12">
            <div class="text-normal">
              <p>
                Meralco is limited to facilitating electrical works up to the customer’s meter only. With this restriction but with the intent to help customers on their electricity-related concerns, it has created an avenue where customers can select reliable and dependable contractors to expedite electrical facility installation inside your premises (or loadside). Customers may opt to avail the services of a private electrical contractor certified by Meralco, which are composed of energy service providers, contractors, developers, and designers with the objective of assisting in complying with the technical requirements before Meralco energizes your premises, thereby easing out the burden of you doing personally the completion of process or works.
              </p>
            </div>
          </div>
        </div>
        <br>
          <div class="row clear">
            <div class="col-12">
              <div class="text-header">
                What are the advantages of availing licensed electricians and contractors?
              </div>
              <br>
                <div class="text-normal">
                  They can handle the technical and documentary requirements for your service application making the process safe and convenient for you.
                  <br>
                    <br>
                      Private electrical contractors certified by Meralco engage in continuous training to ensure compliance to technical and customer service standards. Rest assured that you will receive professional service at reasonable rates.
                    </div>
                  </div>
                </div>
                <br>
                  <div class="row clear">
                    <div class="col-12">
                      <div class="text-header">
                        Who are the private electrical contractors certified by Meralco?
                      </div>
                      <br>
                        <div class="text-normal">
                          Please see the table below for the complete list of contractors as of {{date}}
                          <br>
                            <br>
                              Disclaimer: Private electrical contractors certified by Meralco are not employees or agents of Meralco, nor are they affiliates or subsidiaries of Meralco. Transactions made with them do not involve Meralco. Customers will be dealing with them at their own discretion.
                            </div>
                          </div>
                        </div>
                        <br>
                          <a id="contractors"></a>
                          <div class="row clear">
                            <div class="col-lg-4 col-md-12 col-sm-12 table-header">
                              Contractor Name
                            </div>
                            <div class="col-lg-8 col-md-12 col-sm-12 table-header mobile-hidden">
                              Areas They Serve
                            </div>
                          </div>
                          <div class="row clear">
                            <div class="col-12 clear">
                              <div class="d-flex flex-column">
                                @for (item of cbmList; track item; let i = $index) {
                                  <div class="cbm-item-container"
                                    [ngClass]="{'cbm-item-even': i %2== 0 }">
                                    <div class="cbm-item-name">
                                      <div class="name">{{ item.name }}</div>
                                      <div class="number">PCAB License No. {{ item.number }}</div>
                                    </div>
                                    <div class="cbm-item-areas">
                                      @for (area of item['areas']; track area) {
                                        <div class="area">
                                          {{ area['name'] }}
                                        </div>
                                        <div class="cities">{{area['cities']}}</div>
                                      }
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                          <br>
                            <div class="row clear">
                              <div class="col-12 text-normal">
                                For further information, reach us through hotline <span style="color: #5F96BA">1622-7226</span> or email us at
                                <a  href="mailto:contactus@peccbm.ph"
                                style="color: #5F96BA">contactus&#64;peccbm.ph</a>.
                              </div>
                            </div>
                          </div>
                          <br>
                            <br>
                              <br>
                              </div>
